import React from "react";

export const AnchorButton = (
  props: React.ButtonHTMLAttributes<HTMLButtonElement>,
) => {
  return <button type="button" className="link-button" {...props} />;
};
